import {OwnershipGroup} from '../../kit/groups/OwnershipGroup';
import {useVehicleFormContext} from '../../kit/hooks/useVehicleFormContext';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function MileageOwnershipSubSection() {
  const {vehicleId} = useVehicleFormContext();

  return (
    <VFKit.SubSection data-testid="mileage-ownership">
      <VFKit.Group data-testid="mileage-fields" columns={[1, 2, 4]}>
        <VFKit.SimpleMileageField name="mileage" vehicleId={vehicleId} />
        <VFKit.RealMileageInput />
        <OwnershipGroup />
      </VFKit.Group>
    </VFKit.SubSection>
  );
}
